'use client';

import { type Session } from 'next-auth';
import { SessionProvider } from 'next-auth/react';
import { BASE_PATH } from '@/constants/constants';

export function AuthSesssionProvider({ children, session }: { children: React.ReactNode; session: Session | null | undefined }) {
	return (
		<SessionProvider session={session} basePath={`${BASE_PATH}/speedboat/api/auth`}>
			{children}
		</SessionProvider>
	);
}
